import qs from 'qs';

import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';
import client from './rest/AdminClient';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';

const Actions = AdminConstants.ActionTypes;
const api1 = 'api/1/';

const ajax = {
  get(url, ...parts) {
    let newUrl = url;
    // Parse arguments
    if (parts.length > 0) {
      if (parts[0].constructor === Object) {
        newUrl += `?${qs.stringify(parts[0])}`;
      } else {
        parts.forEach((part) => {
          newUrl += `/${part}`;
        });
      }
    }

    return client({
      method: 'GET',
      path: newUrl,
    });
  },

  method(method, url, data) {
    return client({
      method: method.toUpperCase(),
      path: url,
      entity: JSON.stringify(data),
    });
  },
};

const Utils = {
  getMarkets() {
    return ajax
      .get(`${api1}markets`)
      .then((res) => {
        AdminServerActionCreators.receiveMarkets(res.entity.markets);
        return res;
      })
      .catch((err) => {
        console.log(err.stack || err);
      });
  },

  getMarketsV2() {
    return new Promise((resolve, reject) => {
      ajax.get(`${api1}markets`)
        .then((res) => {
          if (res.entity && res.entity.markets) {
            return resolve(res.entity.markets);
          }
          resolve(null);
        })
        .catch((err) => {
          console.log(err.stack || err);
          reject(new Error(err.stack || err));
        });
    });
  },

  getMarket(id) {
    return ajax
      .get(`${api1}markets/${id}`)
      .then((res) => {
        AdminServerActionCreators.receiveMarket(res.entity);
        return res;
      })
      .catch((err) => {
        console.log(err.stack || err);
      });
  },

  findMarket(coords) {
    const queryString = qs.stringify({ near: coords });
    return ajax
      .get(`${api1}markets/?${queryString}`)
      .then((res) => {
        AdminServerActionCreators.findMarketSuccess(res.entity.market);
        return res;
      })
      .catch((err) => {
        AdminServerActionCreators.findMarketFail(err.entity ? err.entity.error : err);
      });
  },

  findMarketV2(coords) {
    const queryString = qs.stringify({ near: coords });
    return ajax
      .get(`${api1}markets/?${queryString}`).then(
        response => { return response.entity.market },
        response => { return response.entity ? response.entity.error : response }
      );
  },
};

// Fetch on action
AdminAppDispatcher.register((payload) => {
  const id = payload.action.id;

  switch (payload.action.type) {
    case Actions.MARKETS_FETCH:
      Utils.getMarkets();
      break;
    case Actions.MARKET_FETCH:
      Utils.getMarket(id);
      break;
    case Actions.FIND_MARKET:
      Utils.findMarket(payload.action.coords);
      break;
    default:
  }
});

export default Utils;
